import { PaysafeEventHandler } from './paysafe-event-handler.type';
import { PaysafeFieldEvent } from './paysafe-field-event.interface';

export interface PaysafeField {
  blur: PaysafeFieldEvent;
  fieldValueChange: PaysafeFieldEvent;
  focus: PaysafeFieldEvent;
  invalid: PaysafeFieldEvent;
  invalidCharacter: PaysafeFieldEvent;
  isEmpty: () => boolean;
  isValid: () => boolean;
  on: (selector: string, eventHandler: PaysafeEventHandler) => void;
  valid: PaysafeFieldEvent;
}
